export function NotificationsEmpty() {
  return (
    <div className="flex flex-col items-center justify-center py-8 px-4 text-center">
      <svg width="80" height="70" viewBox="0 0 80 70" fill="none" className="mb-4 text-muted-foreground/30">
        <circle cx="40" cy="30" r="20" stroke="currentColor" strokeWidth="2" />
        <path d="M32 30l6 6 12-12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.5" />
        <path d="M35 55h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
      <h3 className="text-sm font-semibold text-foreground mb-0.5">
        Você está em dia!
      </h3>
      <p className="text-xs text-muted-foreground">
        Sem novas notificações.
      </p>
    </div>
  );
}
